import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forgotpassres, login } from '../Models/login';
import { Observable } from 'rxjs';
import { email, update } from '../Models/update';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpClient) { }

  baseurl=`${environment.baseUrl}`





loginAuthentication(login: login): Observable<login> {
  debugger

  const loginData = {
    email: login.email,
    password: login.password,
    roleId: 1 
  };  
    return this.http.post<login>(`${this.baseurl}/auth/login-user`, loginData);
  }

  updatePassword(content: update): Observable<update> {
    return this.http.post<update>(`${this.baseurl}/auth/verify-password`, content);
  }

  newUpdatepass(newpass: update): Observable<update> {
    return this.http.put<update>(`${this.baseurl}/auth/update-password`, newpass)
  }

  verifyEmails(email: email): Observable<email> {
    debugger
    return this.http.post<email>(`${this.baseurl}/email/verify-Updated-email`, email)
  }

  verifyOtp(emailotp: email) {
    debugger
    return this.http.post<email>(`${this.baseurl}/email/send-otp-to-updated-email`, emailotp)
  }
getToken(): string | null {
    return localStorage.getItem('token') || sessionStorage.getItem('token');
  }
  sendOtpForForgottedPassword(email:string){
    return this.http.post<forgotpassres>(`${this.baseurl}/email/send-otp-for-forgot-password`,{email})
  }
  
forgotPasswordVerifyOTPservice(email:string,otp:string){
return this.http.post(`${this.baseurl}/email/forgot-password/verify-otp`,{email,otp})
}
updateForgottedpassword(email:string,newPassword:string){
  return this.http.put<forgotpassres>(`${this.baseurl}/auth/update-forgotted-password`,{email,newPassword})
}

  isLoggedIn(): boolean {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    return !!token; 
  }
}

